import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { uploadNoticeData } from '../../Services/Employees';
import '../Allocation/Allocation.css';

const NOTICE_SECTIONS = [
  { value: 'WhatNew', label: "What's New" },
  { value: 'PublicNotice', label: 'Public Notice' },
  { value: 'Result', label: 'Exam Schedule/Result' },
];

const UploadNotice = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [heading, setHeading] = useState('');
  const [section, setSection] = useState('Result');
  const [responseMsg, setResponseMsg] = useState('');
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (responseMsg !== '') {
      withReactContent(Swal).fire({
        icon: 'success',
        text: responseMsg,
        allowOutsideClick: false,
      });
      setResponseMsg('');
    }
  }, [responseMsg]);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  const handleUpload = () => {
    if (!heading.trim()) {
      withReactContent(Swal).fire({
        icon: 'warning',
        text: 'Please enter a heading.',
        allowOutsideClick: false,
      });
      return;
    }

    if (!selectedFile) {
      withReactContent(Swal).fire({
        icon: 'warning',
        text: 'Please choose a PDF file.',
        allowOutsideClick: false,
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('heading', heading.trim());
    formData.append('section', section);

    uploadNoticeData(formData)
      .then((response) => {
        setResponseMsg(response.data.message || 'Notice uploaded successfully');
        setHeading('');
        setSelectedFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      })
      .catch((error) => {
        const message = error.response?.data?.message || 'Error uploading notice';
        withReactContent(Swal).fire({
          icon: 'error',
          text: message,
          allowOutsideClick: false,
        });
      });
  };

  return (
    <div className="card border-0" style={{ background: 'white' }}>
      <h3 style={{ textAlign: 'center' }}>Upload Notification</h3>
      <div className="excel-upload-container" style={{ marginBottom: '16%', marginTop: '2%', width: '600px' }}>
        <h2 className="upload-heading">Upload PDF Notice</h2>

        <FormGroup className="text-start mb-3">
          <Label for="noticeSection">Section</Label>
          <Input
            id="noticeSection"
            type="select"
            value={section}
            onChange={(e) => setSection(e.target.value)}
          >
            {NOTICE_SECTIONS.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup className="text-start mb-3">
          <Label for="noticeHeading">Heading</Label>
          <Input
            id="noticeHeading"
            type="text"
            placeholder="e.g. Exam Schedule for July 2026 Event"
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
          />
        </FormGroup>

        <div className="upload-btn-wrapper">
          <button type="button" className="upload-btn" onClick={handleChooseFile}>
            Choose PDF
          </button>
          <input
            type="file"
            accept=".pdf,application/pdf"
            onChange={handleFileChange}
            ref={fileInputRef}
            className="file-input"
          />
        </div>

        {selectedFile && (
          <p className="selected-file">Selected file: {selectedFile.name}</p>
        )}

        <div style={{ marginTop: '10px' }}>
          <button type="button" onClick={handleUpload} className="upload-btn">
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadNotice;
